import { type ReactNode } from 'react';
import { graphql, type PreloadedQuery, usePreloadedQuery } from 'react-relay';

import type { tenantContextProviderQuery } from './__generated__/tenantContextProviderQuery.graphql';
import type { TenantDataContextType } from './tenant-context';
import { TenantDataContext } from './tenant-context';

export const TenantContextProvider = ({
	children,
	queryRef,
}: {
	children: ReactNode;
	queryRef: PreloadedQuery<tenantContextProviderQuery>;
}) => {
	const data = usePreloadedQuery<tenantContextProviderQuery>(
		graphql`
			query tenantContextProviderQuery($hostNames: [String!]) {
				tenantContexts(hostNames: $hostNames) @required(action: THROW) {
					cloudId @required(action: THROW)
					orgId @required(action: THROW)
					activationIdByProduct(product: "devai") {
						active
					}
					entitlementInfo(hamsProductKey: "devai.ondemand") {
						entitlementId
					}
				}
			}
		`,
		queryRef,
	);

	const tenantData: TenantDataContextType = {
		tenantContexts: data.tenantContexts
			.filter((context): context is NonNullable<typeof context> => context !== null)
			.map((context) => ({
				cloudId: context.cloudId,
				orgId: context.orgId,
				devaiEntitlementId: context.entitlementInfo?.entitlementId ?? null,
				devAiActivationId: context.activationIdByProduct?.active ?? null,
			})),
	};

	return <TenantDataContext.Provider value={tenantData}>{children}</TenantDataContext.Provider>;
};
